// extracted by mini-css-extract-plugin
module.exports = {"emptyStateText":"EmptyState_emptyStateText__1eFrf"};